export const CONFIDENCE_OPTIONS = ['low', 'medium', 'high'] as const;

export type ConfidenceOption = (typeof CONFIDENCE_OPTIONS)[number];
